import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon, BookOpenIcon, UsersIcon } from 'lucide-react';
import Button from '../ui/Button';
import { motion, AnimatePresence } from 'framer-motion';
import OptimizedImage from '../ui/OptimizedImage';
const Hero = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const images = ['https://uploadthingy.s3.us-west-1.amazonaws.com/3DHAcubmTqmT13YpTTNQmr/WhatsApp_Image_2025-10-24_at_10.01.24.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/de3EQh38fKgVchW9xJS4du/WhatsApp_Image_2025-10-24_at_10.01.26.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/c8nkRq8o8BbU7KKu56ZSnF/WhatsApp_Image_2025-08-14_at_15.45.37_%285%29.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/hgRGwnKLZHVDTRdgag3Y5F/WhatsApp_Image_2025-10-24_at_10.01.11.jpg', 'https://uploadthingy.s3.us-west-1.amazonaws.com/xwrtKazFgq7H6urQHRmWav/WhatsApp_Image_2025-10-24_at_10.01.12_%281%29.jpg'];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % images.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);
  return <div className="relative bg-blue-900 text-white overflow-hidden min-h-[600px] md:min-h-[700px]" data-id="element-193">
      <AnimatePresence mode="wait" data-id="element-194">
        <motion.div key={currentImage} className="absolute inset-0 z-0" initial={{
        opacity: 0,
        scale: 1.1
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1.5,
        ease: 'easeOut'
      }} data-id="element-195">
          <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-blue-900/70 z-10" data-id="element-196"></div>
          <OptimizedImage src={images[currentImage]} alt="Isonyin Grammar School" className="w-full h-full" objectFit="cover" priority={currentImage === 0} data-id="element-197" />
        </motion.div>
      </AnimatePresence>
      <div className="container mx-auto px-4 py-16 md:py-24 lg:py-32 relative z-10" data-id="element-198">
        <div className="grid md:grid-cols-5 gap-8 items-center" data-id="element-199">
          <div className="md:col-span-3" data-id="element-200">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-yellow-500 text-blue-900 inline-block px-3 py-1 rounded-full text-sm font-bold mb-4" data-id="element-201">
              Admission Open for 2025/2026
            </motion.div>
            <motion.h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 md:mb-6 leading-tight" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} data-id="element-202">
              Shaping Tomorrow's Leaders at Isonyin Grammar School
            </motion.h1>
            <motion.p className="text-lg md:text-xl mb-6 md:mb-8 text-gray-200 max-w-2xl" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.6
          }} data-id="element-203">
              Building future leaders through quality education, character
              development, and a commitment to excellence since our
              establishment.
            </motion.p>
            <motion.div className="flex flex-wrap gap-4" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.8
          }} data-id="element-204">
              <Button href="/admissions" variant="primary" size="lg" icon={<ArrowRightIcon data-id="element-206" />} iconPosition="right" animation="scale" data-id="element-205">
                Apply Now
              </Button>
              <Button href="/virtual-tour" variant="outline" size="lg" className="bg-blue-800/50 border-white text-white hover:bg-blue-700" data-id="element-207">
                Take a Virtual Tour
              </Button>
            </motion.div>
            <motion.div className="mt-8 md:mt-12 flex flex-wrap items-center gap-6 md:gap-8" initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 1
          }} data-id="element-208">
              <div className="flex items-center" data-id="element-209">
                <div className="bg-blue-800/70 p-3 rounded-full" data-id="element-210">
                  <BookOpenIcon className="h-5 w-5 md:h-6 md:w-6 text-yellow-400" data-id="element-211" />
                </div>
                <div className="ml-3" data-id="element-212">
                  <div className="text-xs md:text-sm text-gray-300" data-id="element-213">
                    Established
                  </div>
                  <div className="font-bold text-sm md:text-base" data-id="element-214">
                    March 23, 1956
                  </div>
                </div>
              </div>
              <div className="flex items-center" data-id="element-215">
                <div className="bg-blue-800/70 p-3 rounded-full" data-id="element-216">
                  <UsersIcon className="h-5 w-5 md:h-6 md:w-6 text-yellow-400" data-id="element-217" />
                </div>
                <div className="ml-3" data-id="element-218">
                  <div className="text-xs md:text-sm text-gray-300" data-id="element-219">
                    Alumni Network
                  </div>
                  <div className="font-bold text-sm md:text-base" data-id="element-220">
                    20,000+ Worldwide
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
          <motion.div className="md:col-span-2 hidden md:block" initial={{
          opacity: 0,
          x: 50,
          rotate: -5
        }} animate={{
          opacity: 1,
          x: 0,
          rotate: 2
        }} transition={{
          duration: 0.7,
          delay: 0.5,
          type: 'spring',
          stiffness: 100
        }} data-id="element-221">
            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-lg shadow-lg border border-white/20 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-222">
              <h3 className="text-xl font-bold mb-4" data-id="element-223">Upcoming Events</h3>
              <div className="space-y-4" data-id="element-224">
                <div className="flex items-start" data-id="element-225">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded p-2 text-center min-w-[60px]" data-id="element-226">
                    <div className="text-lg" data-id="element-227">15</div>
                    <div className="text-xs" data-id="element-228">NOV</div>
                  </div>
                  <div className="ml-3" data-id="element-229">
                    <div className="font-bold" data-id="element-230">
                      Inter-House Sports Competition
                    </div>
                    <div className="text-sm text-gray-300" data-id="element-231">
                      School Sports Ground, 9:00 AM
                    </div>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-232">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded p-2 text-center min-w-[60px]" data-id="element-233">
                    <div className="text-lg" data-id="element-234">25</div>
                    <div className="text-xs" data-id="element-235">FEB</div>
                  </div>
                  <div className="ml-3" data-id="element-236">
                    <div className="font-bold" data-id="element-237">PTA General Meeting</div>
                    <div className="text-sm text-gray-300" data-id="element-238">
                      School Hall, 10:00 AM
                    </div>
                  </div>
                </div>
                <div className="flex items-start" data-id="element-239">
                  <div className="bg-yellow-500 text-blue-900 font-bold rounded p-2 text-center min-w-[60px]" data-id="element-240">
                    <div className="text-lg" data-id="element-241">15</div>
                    <div className="text-xs" data-id="element-242">MAR</div>
                  </div>
                  <div className="ml-3" data-id="element-243">
                    <div className="font-bold" data-id="element-244">Annual Alumni Reunion</div>
                    <div className="text-sm text-gray-300" data-id="element-245">
                      School Grounds, 12:00 PM
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-4 text-right" data-id="element-246">
                <Link to="/events" className="text-yellow-400 hover:text-yellow-300 flex items-center justify-end text-sm font-medium" data-id="element-247">
                  View All Events <ArrowRightIcon className="ml-1 h-4 w-4" data-id="element-248" />
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <div className="absolute bottom-0 left-0 w-full h-16 bg-gradient-to-t from-blue-950 to-transparent z-10" data-id="element-249"></div>
    </div>;
};
export default Hero;